import PromoForm from './PromoForm'
export {PromoForm}
export default PromoForm
